export { fetchTypeahead } from 'next-flight-server-reference-proxy-loader?id=7f2df7cde9088c80b036e54c49673f2d78860f93a9&name=fetchTypeahead!'